import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "height": "calc(100vh - 60px)",
    "width": "100vw"
  }
};
const _hoisted_2 = {
  key: 2
};
const _hoisted_3 = {
  class: "card-header"
};
const _hoisted_4 = {
  class: "introduction"
};
const _hoisted_5 = {
  class: "detail"
};
import { ref, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
export default {
  __name: 'Proudct',
  setup(__props) {
    const looplist = ref([]);
    let id = ref(0);
    let bannerHeight = ref(300);
    let screenWidth = window.innerWidth;
    let fyimg = ref();
    const onChange = (cur, pre) => {
      id.value = cur;
      // console.log(id.value);
    };
    const onResize = function () {
      screenWidth = window.innerWidth;
      bannerHeight.value = 0.41 * screenWidth;
    };
    onMounted(async () => {
      // 获取产品信息：
      const res = await axios.get('/webapi/product/list');
      console.log(res.data.data);
      looplist.value = res.data.data;
      // await nextTick(()=>{
      //    if(fyimg.value){
      //    bannerHeight.value = fyimg.value[0].offsetHeight;

      // }

      // })
      bannerHeight.value = 600 / 1550 * screenWidth;
      window.addEventListener('resize', onResize);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', onResize);
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [looplist.value.length ? (_openBlock(), _createBlock(_component_el_carousel, {
        key: 0,
        "indicator-position": "outside",
        height: _unref(bannerHeight) + 'px',
        direction: "horizontal",
        autoplay: true,
        "pause-on-hover": true,
        onChange: onChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(looplist.value, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item._id
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              class: "items",
              fit: "scale-down",
              ref_for: true,
              ref_key: "fyimg",
              ref: fyimg,
              src: `https://www.fomyom.com/fyimg${item.cover}`
            }, null, 8, ["src"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["height"])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "企业暂未添加或发布产品信息"
      })), looplist.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_card, {
        class: "box-card"
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, "产品介绍:" + _toDisplayString(_unref(id) == null ? '请稍候' : looplist.value[_unref(id)].title), 1)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(id) == null ? '' : looplist.value[_unref(id)].introduction), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(id) == null ? '' : looplist.value[_unref(id)].detail), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
};